import { useEffect, useState } from "react";

export const useFilter = (datas) => {
    const [data, setData] = useState(datas);
    const [filterKey, setFilterKey] = useState({ departure: "", month: "", year: ""});

    useEffect(() => {
        // filter data by filter key
        setData(
            datas?.filter((data) => {
                let time = new Date(data.time || data.createAT);
                
                return (
                    (!filterKey.departure || data.departure.country === filterKey.departure) &&
                    (!filterKey.month || (time.getMonth() + 1).toString() === filterKey.month) &&
                    (!filterKey.year || time.getFullYear().toString() === filterKey.year)
                )
            })
        );
    }, [filterKey.departure, filterKey.month, filterKey.year, datas])

    const filterHandler = (event) => {
        // change handler
        const { id, value } = event.target;
        
        setFilterKey((previus) => ({
            ...previus,
            [id]: value
        }))
    };

    const resetFilter = () => setFilterKey({ departure: "", month: "", year: "" })

    return { data, filterHandler, resetFilter };
};
